<template>
	<sideNav :page-title="pageTitle"></sideNav>
	<div v-show="showFlag">
		<div class="ld-panel-title">
			<router-link to="/verify" class="back-btn"><span></span>企业认证</router-link>
		</div>
		<div class="ld-panel-main">
			<el-alert title="根据《中华人民共和国网络安全法》等网络安全相关法律法规规定，及按网监，公安等有关监管单位要求，云计算资源用户须完成用户实名认证才能使用云服务。请您认真填写相关实名认证信息，完成实名认证申请。" type="warning" show-icon :closable="false" />
			<el-result icon="warning" title="实名认证已经提交，请耐心等候客服与您联系核实" />
		</div>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import { authInfo } from '@/api/auth';
	import { useRouter } from 'vue-router';
	import sideNav from '../../components/sideNav.vue';
	
	const router = useRouter();
	const pageTitle = 'account';
	const showFlag = ref(false);
	
	
	const generData = () => {
		authInfo().then((res) => {
			if(res.code === 200){
				if (res.data.authStatus == '1' && res.data.authType == '2') {
					router.push({ path: '/verify/success' })
				}
				if (res.data.businessStatus == '3') {
					router.push({ path: '/verify/businessinfo' })
				}else if(res.data.businessStatus == '4'){
					router.push({ path: '/verify/check' })
				}else{
					showFlag.value = true;
				}
			}
		})
	};
	
	onMounted(() => {
		generData()
	})

</script>

<style scoped>
	
</style>